import api from './api';
import { useQuotesStore } from '@/store/quotes';

// El total de citas en base de datos que devuelve el backend en /quotes
// se usa en MelonRain.vue (cantidad de trozos de melón de fondo). Se
// centraliza aquí para que se mantenga al día sin importar desde qué
// pantalla se haya disparado el GET (feed general, perfil o búsqueda).
function syncTotal(total) {
  if (total === undefined) return;
  useQuotesStore().total = total;
}

class QuoteService {
  async getQuotes({ before, limit = 10 } = {}) {
    const response = await api.get('/quotes', { params: { before, limit } });
    syncTotal(response.data.total);
    return response.data;
  }

  async getUserQuotes({ userId, before, limit = 10 } = {}) {
    const response = await api.get('/quotes', { params: { userId, before, limit } });
    syncTotal(response.data.total);
    return response.data;
  }

  async getBookQuotes({ bookId, before, limit = 10 } = {}) {
    const response = await api.get('/quotes', { params: { bookId, before, limit } });
    return response.data;
  }

  async getAuthorQuotes({ authorId, before, limit = 10 } = {}) {
    const response = await api.get('/quotes', { params: { authorId, before, limit } });
    return response.data;
  }

  async searchQuotes({ quote, before, limit = 10 } = {}) {
    const response = await api.get('/quotes', { params: { quote, before, limit } });
    syncTotal(response.data.total);
    return response.data;
  }

  async createQuote({ bookId, quote }) {
    const response = await api.post('/quotes', { book_id: bookId, quote });
    return response.data;
  }

  async deleteQuote(id) {
    await api.delete(`/quotes/${id}`);
  }

  async updateQuote(id, { bookId, quote }) {
    const response = await api.patch(`/quotes/${id}`, { book_id: bookId, quote });
    return response.data;
  }
}

export default new QuoteService();